import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  Select,
  Typography,
  Divider,
  Tag,
  DatePicker,
  Space,
  Button,
  message,
  Pagination,
  Empty,
  Spin
} from "antd";
import {
  SearchOutlined,
  UserOutlined,
  ClockCircleOutlined,
  MessageOutlined,
  ArrowRightOutlined
} from "@ant-design/icons";
import moment from "moment";
import _commonService from "../../modules/commonService";
import { useHistory } from "react-router-dom";
import StatusTag from "../../components/StatusTag";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import { applicationStatus, UnderReviewUnderwriterBanker,UnderReviewPrivateBankerId,LoanOfficerReviewStatusId, PRIVATE_WEALTH_ADVISOR_ROLE, COMPLIANCE_ADMINISTRATOR_ROLE, UNDERWRITER_BANKER_ROLE } from "../../constants/DataConstants";
import _NewapplicationService from "../../modules/NewapplicationService";
import ButtonComponent from "../../components/Button/Button";
import "./ApplicationList.scss";

const { Title, Text } = Typography;
const { Option } = Select;

const ApplicationList = ({
  allApplications = [],
  searchTerm,
  applicationStatusForFilter,
  sortBy,
  fromDate, // [moment, moment]
  toDate,
  onSearchChange,
  fromDateChange,
  toDateChange,
  onSortChange,
  onApplicationStatusChange,
  onClearFilters,
  pageIndex,
  pageSize,
  totalCount,
  onPaginationChange,
  isFromLoanOfficerDashboard
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const bankerIdRaw = localStorage.getItem("BankerId");
  const bankerId = bankerIdRaw ? parseInt(bankerIdRaw) : null;

  const LoanOfficerId = localStorage.getItem("LoanOfficerId");
  const loanOfficerID = LoanOfficerId ? parseInt(LoanOfficerId) : null;
  const [applicationStatusData, setApplicationStatusData] = useState([]);
  const isPrivateWealthAdvisor = localStorage.getItem("userRole") === PRIVATE_WEALTH_ADVISOR_ROLE;
  const isComplianceAdministrator = localStorage.getItem("userRole") === COMPLIANCE_ADMINISTRATOR_ROLE;
  const isUnderwriterBanker = localStorage.getItem("userRole") === UNDERWRITER_BANKER_ROLE;
  const RoleId = Number(localStorage.getItem("RoleId") ?? 0);
  const isSeniorPrivateBanker = localStorage.getItem("userRole") === "Senior Private Banker";
  const isLoanOfficer = localStorage.getItem("userRole") === "Loan Officer";

  const handleClickUpdateApplicantStatus = async (item) => {
    if (isPrivateWealthAdvisor) {
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
      return;
    }

        // Only call API when status is 6,7 and 8, for other status just redirect to details page
    // if (item?.Application_Status_Id !== 6 && item?.Application_Status_Id !== 8 && item?.Application_Status_Id !== 7) {
    //   history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
    //   return;
    // }

    // Status IDs for which this click should just navigate to the details page instead of
    // calling the "claim review" API below (kept as separate lists per role, matching the
    // original three-way branch, even though the Loan Officer and default lists are currently
    // identical).
    const SENIOR_PRIVATE_BANKER_DETAILS_ONLY_STATUS_IDS = [3, 8, 11, 12, 13, 14, 16];
    const LOAN_OFFICER_DETAILS_ONLY_STATUS_IDS = [5, 7, 9, 12, 13, 14, 15, 16];
    const DEFAULT_DETAILS_ONLY_STATUS_IDS = [5, 7, 9, 11, 12, 13, 14, 15, 16];
    const isStatusOneOf = (statusIds) => statusIds.some((statusId) => item?.Application_Status_Id == statusId);

    const isDetailsOnlyStatus = isSeniorPrivateBanker
      ? isStatusOneOf(SENIOR_PRIVATE_BANKER_DETAILS_ONLY_STATUS_IDS)
      : loanOfficerID
        ? isStatusOneOf(LOAN_OFFICER_DETAILS_ONLY_STATUS_IDS)
        : isStatusOneOf(DEFAULT_DETAILS_ONLY_STATUS_IDS);

    if (isDetailsOnlyStatus) {
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
      return;
    }

    if (item && item.Application_Status_Id && (item.Application_Status_Id != 4 && item.Application_Status_Id != 5 && item.Application_Status_Id != 9)) {
      let reqObj = {
        Id: item.Id,
        ApplicationId: item.ApplicationId,
        Application_Status_Id: isFromLoanOfficerDashboard ? LoanOfficerReviewStatusId :isSeniorPrivateBanker ? UnderReviewPrivateBankerId : UnderReviewUnderwriterBanker,
        BankerId: isFromLoanOfficerDashboard ? null : bankerId,
        LoanOfficerId: isFromLoanOfficerDashboard ? loanOfficerID : null,
        RoleId: RoleId || null
      }
      setLoading(true);
      try {

        if (isComplianceAdministrator) {
          history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
        } else {
          const res = await _BankerService.updateApplicantStatus(reqObj);
    //  debugger     
          if (res.data.IsSuccess) {
            setLoading(false);
            history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
          } else {
            setLoading(false);
            message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
          }

        }

      } catch (err) {
        setLoading(false);
        console.log(err);
      }
      finally {
        setLoading(false);
      }
    } else {
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
    }
  }

  useEffect(() => {
    getApplicationStatus();
  }, []);

  const getApplicationStatus = async () => {
    try {
      let dropdownName;
      if (isComplianceAdministrator) {
        dropdownName = "applicationstatuscomplienceadmin";
      } else if (isFromLoanOfficerDashboard) {
        dropdownName = "applicationstatusloanofficer";
      } else if (isUnderwriterBanker) {
        dropdownName = "applicationstatusunderwriter";
      } else {
        dropdownName = "applicationstatus";
      }
      const res = await _NewapplicationService.getAllDropdownDataByName(dropdownName);
      if (res.data) {
        setApplicationStatusData(res.data);
      }
    } catch (e) {
      console.log(e);

    }
  };

  const currentMonthYear = _commonService.getCurrentMonthAndYear();
  const getScoreClass = (isGood) =>
    isGood ? "score-green" : "score-red";
  return (
    <Spin spinning={loading}>
      <div className="application-list-view">

        <Row gutter={[0, 32]} >
          <Col span={24}>
            <Title level={3} className="page-title">
              All Loan Applications
            </Title>
            <Title level={5} className="page-subtitle">Monthly Review, {currentMonthYear}</Title>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 16]} className="fitlers card-section">
              <Col xs={24} sm={12} md={5} lg={5}>
                <Input
                  value={searchTerm}
                  onChange={(e) => onSearchChange?.(e.target.value)}
                  placeholder="Search Application"
                  prefix={<SearchOutlined />}
                  style={{ borderRadius: 50, minWidth: 200, height: 38 }}
                  className="filterInput cardViewMain"
                />
              </Col>

              <Col xs={24} sm={12} md={4} lg={5}>
                <Select
                  // allowClear
                  value={applicationStatusForFilter}
                  onChange={(value) => onApplicationStatusChange?.(value)}
                  placeholder="Application Status"
                  style={{ width: "100%" }}
                  className="cardViewMain"
                  dropdownClassName="cardViewMainDropdown"
                >
                  {applicationStatusData && applicationStatusData.map((obj) => (
                    <Option key={obj.Id} value={obj.Id}>
                      {obj.Name}
                    </Option>
                  ))}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={4} lg={3}>
                {/* <Text style={{ marginRight: 8 }}>From:</Text> */}
                <DatePicker
                  style={{ width: "100%" }}
                  allowClear
                  value={fromDate}
                  onChange={fromDateChange}
                  placeholder="From Date"
                  format="MM/DD/YYYY"
                />
              </Col>

              <Col xs={24} sm={12} md={4} lg={3}>
                {/* <Text style={{ marginRight: 8 }}>To:</Text> */}
                <DatePicker
                  style={{ width: "100%" }}
                  allowClear
                  value={toDate}
                  onChange={toDateChange}
                  placeholder="To Date"
                  format="MM/DD/YYYY"
                />
              </Col>

              <Col xs={24} sm={12} md={4} lg={5}>
                <Select
                  allowClear
                  value={sortBy}
                  onChange={onSortChange}
                  placeholder="Sort By"
                  className="cardViewMain"
                  dropdownClassName="cardViewMainDropdown"
                  style={{ width: "100%" }}
                  options={[
                    { label: "Newest First", value: "newest" },
                    { label: "Oldest First", value: "oldest" },
                    { label: "High to Low", value: "high" },
                    { label: "Low to High", value: "low" },
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={3} lg={3}>
                <Button
                  onClick={onClearFilters}
                  type="default"
                  style={{ width: "100%" }}
                  className="clear-btn"
                  disabled={searchTerm === "" && !applicationStatusForFilter && !fromDate && !toDate && !sortBy}
                >
                  Clear Filters
                </Button>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            {/* Application Cards */}
            <Row gutter={[16, 16]} className="applications-container">
              {allApplications && allApplications.map((item, index) => (
                <Col key={index} xs={24} md={24}>
                  <Card className="cardViewMain card-section">
                    <Row gutter={[24, 24]} align="middle">
                      <Col xs={24} sm={24} md={16} lg={16}>
                        <Row gutter={[16, 16]}>
                          <Col span={24}>
                            <div style={{ display: "flex" }}>
                              <StatusTag statusId={item.Application_Status_Id} />
                            </div>
                          </Col>
                          <Col span={24} style={{ display: "grid", rowGap: "12px" }}>
                            <Row gutter={[12, 12]}>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Application ID :</Text>
                                  <Text className="application-info-value">{item.ApplicationId}</Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Date :</Text>
                                  <Text className="application-info-value">{moment(item.CreatedDate).format("MM/DD/YYYY")}</Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Phone :</Text>
                                  <Text className="application-info-value">{item.Phone ? _commonService.formatUSPhoneNumber(item.Phone) : "N/A"}</Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Email :</Text>
                                  <Text className="application-info-value">{item.Email ? item.Email : "N/A"} </Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Firm Name :</Text>
                                  <Text className="application-info-value">{item.SponserCompany ? item.SponserCompany : "N/A"}</Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Remaining Credit Facility Availability :</Text>
                                  <Text className="application-info-value">{_commonService.formatNumberWithCommas(item.Remaining ? `$ ${item.Remaining}` : "N/A")}</Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Client :</Text>
                                  <Text className="application-info-value">{item.FirstName} {item.MiddleName} {item.LastName}</Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={12}>
                                <div className="application-info">
                                  <Text className="application-info-label">Loan Inquiry Amount :</Text>
                                  <Text className="application-info-loan-value">$ {_commonService.formatNumberWithCommas(item.LoanEnquiryFor)}</Text>
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={24} lg={24}>
                                <div className="application-info">
                                  <Text className="application-info-label">Address :</Text>
                                  <Text className="application-info-value">{item.City || "N/A"}, {item.State || "N/A"} - {item.Zip || "N/A"}</Text>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <div className="card-section">
                          <Row gutter={[12, 12]}>
                            <Col span={24} >
                              <div className="banker-score-section">
                                <Text className="banker-score-label">Credit Score :</Text>
                                <div className="banker-score-value-section">
                                  {/* <Text className="banker-score-value">{item.FixCBRScore}</Text>
                                  <ClockCircleOutlined className="banker-score-icon" /> */}
                                  
                                  <Text
                                    className={`banker-score-value ${item.CBRScore < item.FixCBRScore ? "redColor" : "greenColor"}`}
                                    
                                  >
                                    {item.CBRScore}
                                  </Text>
                                  {/* <Text className="banker-score-secondary-value">{item.CBRScore}</Text> */}
                                </div>
                              </div>
                            </Col>
                            <Col span={24} >
                              <div className="banker-score-section">
                                <Text className="banker-score-label">TDSR :</Text>
                                <div className="banker-score-value-section">
                                  {/* <Text className="banker-score-value">{item.FixTDSR}</Text>
                                  <ClockCircleOutlined className="banker-score-icon" /> */}
                                  <Text
                                    className={`banker-score-value ${parseFloat(item.PFTDSR) > parseFloat(item.FixTDSR) ? "redColor" : "greenColor"}`}
                                  >
                                    {item.PFTDSR ? item.PFTDSR + "%" : "N/A"}
                                  </Text>
                                  {/* <Text className="banker-score-secondary-value">{item.PFTDSR ? item.PFTDSR + "%" : "N/A"}</Text> */}
                                </div>
                              </div>
                            </Col>
                            <Col span={24} >
                              <div className="banker-score-section">
                                <Text className="banker-score-label">Leverage :</Text>
                                <div className="banker-score-value-section">
                                  {/* <Text className="banker-score-value">{item.FixLevrage}</Text>
                                  <ClockCircleOutlined className="banker-score-icon" /> */}
                                  <Text
                                    
                                    className={`banker-score-value ${item.Levrage > item.FixLevrage ? "redColor" : "greenColor"}`}
                                  >
                                    {item.Levrage ? item.Levrage : "N/A"}
                                  </Text>
                                  {/* <Text className="banker-score-secondary-value">{item.Levrage ? item.Levrage + "%" : "N/A"}</Text> */}
                                </div>
                              </div>
                            </Col>
                            <Col span={24} className="banker-score-section" >
                              <Divider />
                            </Col>
                            <Col span={24} className="banker-score-footer-section" >
                              <div style={{ display: "flex", position: "relative" }}>
                                <MessageOutlined className="banker-score-footer-icon" />
                                <Text className="banker-score-footer-text" >{item.ApplicationReviewCommentsCount}</Text>
                              </div>
                              <div>
                                {/* <Button
                                type="link"
                                className="fRight viewBtn"
                                onClick={() => { handleClickUpdateApplicantStatus(item) }}
                              >
                                <span>View Application</span><ArrowRightOutlined style={{ fontSize: 'inherit', marginTop: "8px" }} />
                              </Button> */}

                                <ButtonComponent
                                  type="link"
                                  className="fRight viewBtn"
                                  text="View Application"
                                  icon={<ArrowRightOutlined />}
                                  onClick={() => handleClickUpdateApplicantStatus(item)}
                                  iconPosition="right"
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
          {allApplications.length === 0 && (

            <Col span={24}>
              <div style={{ textAlign: "center", marginTop: 20 }}>
                <Empty
                  image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                  styles={{ image: { height: 60 } }}
                  description={
                    <Typography.Text>
                      No Applications found
                    </Typography.Text>
                  }
                />
              </div>

            </Col>
          )}
          <Col span={24} className="pagination" >
            {allApplications.length > 0 && (
              <div className="pgDiv">
                <Pagination
                  showSizeChanger
                  current={pageIndex}
                  pageSize={pageSize}
                  total={totalCount}
                  onChange={onPaginationChange}
                  className={allApplications && allApplications.length < 1 ? "hide" : "fRight"}
                />
              </div>
            )}
          </Col>
        </Row>
      </div>
    </Spin>
  );
}


export default ApplicationList;